module.exports = __webpack_public_path__ + "img/pickup7.3f9305b9.svg";